export const devApiUrl =
  process.env.REACT_APP_AUTOPILOT_API_URL || "http://localhost:8000";

export const appsyncConfig = JSON.parse(
  process.env.REACT_APP_APPSYNC_GRAPHQL_ENDPOINTS || "{}"
);

export const isDevModeDefaultUser = false;
